"use client";

import * as React from "react";

import { FormField } from "./form-field";
import { FileUpload, type FileUploadProps } from "./file-upload";

export type FileUploadFieldProps = FileUploadProps & {
	label?: React.ReactNode;
	labelFor?: string;
	description?: React.ReactNode;
	hint?: React.ReactNode;
	validationMessage?: React.ReactNode;
	isRequired?: boolean;
};

const FileUploadField = React.forwardRef<HTMLDivElement, FileUploadFieldProps>(
	(
		{
			label,
			labelFor,
			description,
			hint,
			validationMessage,
			isRequired,
			isInvalid,
			className,
			...uploadProps
		},
		ref,
	) => (
		<FormField
			label={label}
			labelFor={labelFor}
			description={description}
			hint={hint}
			validationMessage={validationMessage}
			isRequired={isRequired}
			isInvalid={isInvalid}
			className={className}
		>
			<FileUpload
				ref={ref}
				isInvalid={isInvalid}
				{...uploadProps}
				id={uploadProps.id ?? labelFor}
			/>
		</FormField>
	),
);
FileUploadField.displayName = "FileUploadField";

export { FileUploadField };
